// extracted by mini-css-extract-plugin
module.exports = {"root":"inviteList_root__3qVIR","loadingContainer":"inviteList_loadingContainer__2ykBK"};